import { typeAbas } from "@monorepo-web/logic-extrato";
import { layoutType } from "@monorepo-web/pdf-generator";

export type LayoutPageKey = 'ResCart' | 'PerfHist';

export const defaultLayoutPages: Record<typeAbas, layoutType> = {
  'ResCart': [
    'Cards',
    [{ id: 'Retorno', col: 8 }, { id: 'FluxoResgate', col: 4 }],
    [{ id: 'PosicaoRendimento', col: 8, heightID: 'Retorno' }, { id: 'ResumoMovimentacoes', col: 4, heightID: 'FluxoResgate' }],
    ['graficoClasse', 'graficoCustodiante'],
  ],
  'PerfHist': [
    'RetornosNominais',
    'AplicacoesResgate',
    ['RetornoAcumulado', 'EvolucaoPatrimonio'],
    'GanhoFinanceiro'
  ],
  'PosCon': ['PosicaoConsolidada'],
  'RetornoAtivo': ['RetornoAtivo'],
  'CartExp': [
    'alocacaoCarteiraExplodida',
    'Explosao',
  ],
  'FluxoAtivo': ['FluxoAtivos'],
  'FluxoCaixa': [],
  'EstatAvancada': [
    [{ id: 'info1', col: 6 }, { id: 'info2', col: 6 }],
    'retorno_estat',
    'volatilidade',
    'IndiceSharpe'
  ],
};

export const DecodificaNomePagina: Record<typeAbas, string> = {
  'ResCart': 'Resumo Carteira',
  'PerfHist': 'Performance Histórica',
  'PosCon': 'Posição Consolidada',
  'RetornoAtivo': 'Retorno por Ativo',
  'CartExp': 'Carteira Explodida',
  'FluxoAtivo': 'Fluxo de Ativos',
  'FluxoCaixa': 'Fluxo de Caixa',
  'EstatAvancada': 'Estatísticas Avançadas',
}